import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const getContactMethod = (href) => {
  if (/^tel:/i.test(href)) return "phone";
  if (/^mailto:/i.test(href)) return "email";
  try {
    const url = new URL(href);
    if (["wa.me", "api.whatsapp.com", "web.whatsapp.com"].includes(url.hostname)) return "whatsapp";
  } catch {
    return null;
  }
  return null;
};

export const trackContactIntent = (method) => {
  if (!window.__STUDIO_PRERENDER__ && typeof window.gtag === "function") {
    window.gtag("event", "contact_intent", {
      contact_method: method,
      page_path: window.location.pathname,
    });
  }
};

function Analytics() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (!window.__STUDIO_PRERENDER__ && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname + search,
        page_title: document.title,
      });
    }
  }, [pathname, search]);
  useEffect(() => {
    const onClick = (event) => {
      const anchor = event.target.closest?.("a[href]");
      const method = anchor && getContactMethod(anchor.href);
      if (method) trackContactIntent(method);
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);
  return null;
}

export default Analytics;
